module.exports = __webpack_public_path__ + "img/weishang.5047fc94.png";